export const PHONE_INTERNATIONAL_VALUE = 'ZZ';
